<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Users</template>
        </page-header>
        <pro-table
            :resource="resource"
            prefix="/configuration/"
            :fields="fields"
            :filters="filters"
            :filters-loading="filtersLoading"
            :limit="25"
            ref="datatable"
            class="px-6 pt-2"
            @action="actionHandler"
            table-class="text-xs"
            sort="last"
            direction="ASC"
            delete-label="first last"
            with="groups"
            :permissions="true"
            :actions="actions"
        ></pro-table>
    </div>
</template>

<script>
    import DataTableSetup from '../../../mixins/DataTableSetup';

    export default {
        name: "Contacts",
        mixins: [ DataTableSetup ],
        data: function() {
            return {
                resource: 'users',
                numberOfFilters: 2,
                pageActions: {},
                fields: [
                    {
                        name: 'Name',
                        column: 'full_name',
                        route: '/configuration/users/{id}/view',
                        linked: true,
                        sortCol: 'last'
                    },
                    {
                        name: 'Groups',
                        column: 'groups',
                        array: true,
                        field: 'name'
                    },
                    {
                        name: 'Email',
                        column: 'email',
                    },
                    {
                        name: 'Mobile',
                        column: 'mobile',
                    },
                    {
                        name: 'Active',
                        column: 'active',
                        sortCol: false,
                        boolean: true,
                        align: 'center',
                        toggle: true,
                    },
                ],
                actions: {
                    display: true,
                    class: [],
                    options: [
                        { label: 'View', link: 'view', icon: 'eye',  type: 'router-link', tooltip: 'View', permissions: 'users.show' },
                        { label: 'Edit', link: 'edit', icon: 'edit', type: 'router-link', tooltip: 'Edit', permissions: 'users.edit' },
                        { label: 'Delete', method: 'delete', icon: 'trash-alt', type: 'method', tooltip: 'Delete', permissions: 'users.destroy' },
                    ]
                }
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
        },
        mounted() {
            //Search Filter
            const searchFilter = {
                label: 'Search',
                name: 'search',
                type: 'text',
                width: 'w-1/4',
                value: this.searchValue,
                placeholder: 'Search...'
            };

            this.filters.push(searchFilter);

            // Groups Filter
            const groupsFilter = {
                label: 'Group',
                name: 'group',
                type: 'select',
                options: this.$store.getters.userGroups.map(function (group) {
                    return {label: group.name, value: group.id};
                }),
                width: 'w-1/4',
                value: this.groupValue,
                placeholder: 'Select Group...'
            };

            if (this.$store.getters.userGroups.length === 0){
                this.$store.dispatch('GET_GROUPS').then(() => {
                    groupsFilter.options = this.$store.getters.userGroups.map(function (group) {
                        return { label: group.name, value: group.id };
                    });
                    groupsFilter.value = this.groupValue;
                    this.filters.push(groupsFilter);
                    this.$Progress.finish();
                });
            } else {
                this.filters.push(groupsFilter);
            }

            this.pageActions = {
                buttons: [
                    {
                        label: 'New User',
                        icon: 'plus',
                        type: 'router-link',
                        link: '/configuration/users/create',
                        iconClass: 'text-green-600',
                        display: this.$store.getters.permissions.indexOf('users.create') !== -1
                    }
                ],
                additional: []
            }
        },
        computed: {
            groupValue(){
                const filters = this.$store.getters.filters;

                if (!window._.isEmpty(filters.users.group)){
                    return filters.users.group;
                } else {
                    return null;
                }
            },
            searchValue () {
                const filters = this.$store.getters.filters;

                if (filters.users.search){
                    return filters.users.search.value;
                } else {
                    return '';
                }
            }
        }
    }
</script>

<style scoped>

</style>
